/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APICustomerOrder } from './APICustomerOrder';
import {
    APICustomerOrderFromJSON,
    APICustomerOrderFromJSONTyped,
    APICustomerOrderToJSON,
} from './APICustomerOrder';

/**
 * 
 * @export
 * @interface APIPaginatedCustomerOrderList
 */
export interface APIPaginatedCustomerOrderList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedCustomerOrderList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedCustomerOrderList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedCustomerOrderList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APICustomerOrder>}
     * @memberof APIPaginatedCustomerOrderList
     */
    results: Array<APICustomerOrder>;
}

/**
 * Check if a given object implements the APIPaginatedCustomerOrderList interface.
 */
export function instanceOfAPIPaginatedCustomerOrderList(value: object): value is APIPaginatedCustomerOrderList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedCustomerOrderListFromJSON(json: any): APIPaginatedCustomerOrderList {
    return APIPaginatedCustomerOrderListFromJSONTyped(json, false);
}

export function APIPaginatedCustomerOrderListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedCustomerOrderList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APICustomerOrderFromJSON)),
    };
}

export function APIPaginatedCustomerOrderListToJSON(value?: APIPaginatedCustomerOrderList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APICustomerOrderToJSON)),
    };
}

